import axiosHttp from "services/axiosHttp";

// Portfolio Service Functions
export const portfolioService = {
  // Create portfolio
  createPortfolio: async (data) => {
    const response = await axiosHttp.post("/pmo/portfolio", data);
    return response.data;
  },

  // Get portfolio list
  getPortfolioList: async (params) => {
    const response = await axiosHttp.get(`/pmo/portfolio`, { params });
    return response.data;
  },

  // Get single portfolio by ID
  getPortfolio: async (id) => {
    const response = await axiosHttp.get(`/pmo/portfolio/${id}`);
    return response.data;
  },

  // Update portfolio
  updatePortfolio: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/portfolio/${id}`, data);
    return response.data;
  },

  // Delete portfolio
  deletePortfolio: async (id) => {
    const response = await axiosHttp.delete(`/pmo/portfolio/${id}`);
    return response.data;
  },

  // Update portfolio status
  updatePortfolioStatus: async (data) => {
    const response = await axiosHttp.put(`/pmo/portfolio/${data.id}/status/${data.status}`, data);
    return response.data;
  }
};
